import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ConceptData = any;

export type ConceptsState = {
  skills: ConceptData | null;
  softSkills: ConceptData | null;
  specialties: ConceptData | null;
  tools: ConceptData | null;
  industries: ConceptData | null;
  deliverables: ConceptData | null;
};

type SetConceptPayload = {
  target: keyof ConceptsState;
  value: ConceptData;
};

const initialState: ConceptsState = {
  skills: null,
  softSkills: null,
  specialties: null,
  tools: null,
  industries: null,
  deliverables: null,
};

export const conceptsSlice = createSlice({
  name: "concepts",
  initialState,
  reducers: {
    setConcept(state, action: PayloadAction<SetConceptPayload>) {
      const { target, value } = action.payload;
      state[target] = value;
    },
  },
});

export const { setConcept } = conceptsSlice.actions;
